import { create } from 'zustand';
import { login, logout } from '../services/authService';
import { User } from '../types/User';
import {RoleType} from "../types/Role";

interface AuthState {
  isLoggedIn: boolean;
  user: User | null;
  login: (username: string, password: string) => Promise<void>;
  logout: () => void;
  isAuthenticated: () => boolean;
  setIsLoggedIn: (isLoggedIn: boolean) => void;
  roles: RoleType[];
  setRoles: (roles: RoleType[]) => void;
}

export const useAuthStore = create<AuthState>((set, get) => ({
  isLoggedIn: false,
  user: null,
  login: async (username: string, password: string) => {
    try {
      const user = await login(username, password);
      set({ isLoggedIn: true, user });
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  logout: async () => {
    await logout();
    set({
      isLoggedIn: false,
      user: null
    });
  },
  isAuthenticated: () => get().isLoggedIn,
  setIsLoggedIn: (isLoggedIn: boolean) => set({ isLoggedIn }),
  roles: [],
  setRoles: (roles: RoleType[]) => set({ roles }),
}));
